import validateRequiredProps from 'utils/validateRequiredProps';
import moment from 'moment';
import {validate as validateContact} from './CrmContact';
import {Record} from 'immutable';
import isEmpty from 'lodash/isEmpty';

export function validate(activity) {
  const contactErrors = validateContact(activity.crmContact);

  const result = validateRequiredProps(activity, ['crmContactId', 'repId']);

  if (!isEmpty(contactErrors)) {
    result.crmContact = contactErrors;
  }

  return result;
}

export default class CrmActivity extends Record({
  id: undefined,
  repId: undefined,
  date: undefined,
  activityType: undefined,
  crmId: undefined,
  crmDataId: undefined,
  active: undefined,
  crmContactId: undefined, // the EXTERNAL id - a reference to the upstream crm id
  contactId: undefined, // the INTERNAL id - our primary key to the internal contact
  crmContact: undefined,
  rawText: undefined,
  message: undefined,
  crmAccount: undefined,
  crmOpportunity: undefined,
  stage: undefined,
  rep: undefined,
  fileUploadId: undefined,
  callIndexed: undefined,
  duration: undefined,

  // These fields below should be depecated
  account: undefined,
  type: undefined,
  contact: undefined,
  opportunity: undefined,
}) {
  constructor(object = {}) {
    super({
      ...object,
      id: object.crmId || object.id,
      date: object.date ? moment(object.date) : null,
      message: object.rawText ? JSON.parse(object.rawText).message : undefined,
    });
  }
}
